import React from "react";
import { XCircle, AlertTriangle } from "lucide-react";
import classes from "./rejectionModal.module.css";

const RejectionModal = ({
  isOpen,
  onClose,
  onConfirm,
  appointmentDate,
  appointmentTime,
  appointmentDetails,
}) => {
  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <div className={classes.modalHeader}>
          <h2 className={classes.modalTitle}>Reject Booking Request</h2>
          <button className={classes.closeButton} onClick={onClose}>
            <XCircle />
          </button>
        </div>

        <div className={classes.modalBody}>
          <div className={classes.warningIcon}>
            <AlertTriangle size={48} color="#FF4D4F" />
          </div>

          <p className={classes.warningText}>
            Are you sure you want to reject this booking request?
          </p>

          <div className={classes.appointmentDetails}>
            <p className={classes.appointmentInfo}>
              <strong>Date:</strong> {appointmentDate}
            </p>
            <p className={classes.appointmentInfo}>
              <strong>Time:</strong> {appointmentTime}
            </p>
            {appointmentDetails?.amount && (
              <p className={classes.appointmentInfo}>
                <strong>Amount:</strong> ₹{appointmentDetails.amount}
              </p>
            )}
          </div>

          <div className={classes.noteContainer}>
            <p className={classes.noteText}>
              <strong>Note:</strong> Once rejected, this booking request will be
              permanently removed from your dashboard and you will no longer be
              able to accept it.
            </p>
          </div>
        </div>

        <div className={classes.modalFooter}>
          <button className={classes.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <button className={classes.rejectButton} onClick={onConfirm}>
            Reject Request
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;
